/*
  clikt. — cart totals with delivery, kept alive across Dawn's re-renders.

  The markup lives in snippets/clikt-cart-delivery.liquid inside the cart
  footer's `.js-contents`, which Dawn's cart.js replaces wholesale after every
  quantity change or removal. So nothing here binds to a specific element:
  clicks and typing are caught at the document, and a MutationObserver on the
  footer (plus Dawn's cartUpdate event, when present) re-reads the fresh
  data-* attributes and redraws. The postcode the shopper typed is kept for
  the visit so it survives the swap.

  Prices come from window.CliktFulfil.priceFor — the theme's one freight
  table — for the cart's total weight, exactly the two inputs Shopify uses at
  checkout, where the clikt-postcode-guard Function shows the matching lane.
*/
(function () {
  /* the snippet may be rendered twice on a page (cart page + drawer) — run once */
  if (window.__cliktCartDelivery) return;
  window.__cliktCartDelivery = true;
  var KEY = 'clikt-cart-pc';
  /* same shape as Dawn's subtotal on the row above: $1,920.00 */
  var money = function (n) {
    return '$' + Number(n).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  var SETTLE_MS = 700;   // a beat of "checking…" so a new price reads as looked up, like the product page
  var remembered = function () {
    try { var v = sessionStorage.getItem(KEY); if (v) return v; } catch (e) {}
    return '';
  };
  var remember = function (pc) {
    try { sessionStorage.setItem(KEY, pc); } catch (e) {}
    var F = window.CliktFulfil;
    if (F && F.savePostcode) { try { F.savePostcode(pc); } catch (e) {} }
  };

  /* ✓ Dale 18 Sep 2026: five carts is the most an online order can carry —
     above that the rate bands cannot tell six small carts from a 4–5 cart
     mix, so the page asks for a quote instead of guessing. The checkout
     buttons (page and drawer) are disabled while the cart is over. */
  var MAX_CARTS = 5;
  function capCheckout(over) {
    var btns = document.querySelectorAll('button[name="checkout"], .cart__checkout-button');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (over) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); b.dataset.cliktCapped = '1'; }
      else if (b.dataset.cliktCapped) { b.disabled = false; b.removeAttribute('aria-disabled'); delete b.dataset.cliktCapped; }
    }
    var wallets = document.querySelectorAll('.cart__dynamic-checkout-buttons, .shopify-payment-button');
    for (var j = 0; j < wallets.length; j++) wallets[j].style.display = over ? 'none' : '';
  }
  function draw(host, pc) {
    var F = window.CliktFulfil;
    if (!F || !F.priceFor) return;
    var grams = Number(host.getAttribute('data-grams')) || 0;
    var carts = Number(host.getAttribute('data-carts')) || 0;
    var subtotal = (Number(host.getAttribute('data-subtotal')) || 0) / 100;
    var label = host.querySelector('[data-delivery-label]');
    var amt = host.querySelector('[data-delivery-amt]');
    var total = host.querySelector('[data-total]');
    var totalLabel = host.querySelector('[data-total-label]');
    var note = host.querySelector('[data-note]');
    var digits = String(pc || '').replace(/\D/g, '');

    var reset = function (msg) {
      label.textContent = 'Delivery';
      amt.textContent = '—';
      total.textContent = money(subtotal) + ' AUD';
      totalLabel.textContent = 'Estimated total';
      note.textContent = msg;
    };

    capCheckout(carts > MAX_CARTS);
    if (carts > MAX_CARTS) {
      label.textContent = 'Delivery';
      amt.textContent = 'quoted';
      total.textContent = money(subtotal) + ' AUD';
      totalLabel.textContent = 'Subtotal';
      note.textContent = 'Orders of six or more carts are quoted by us: contact us for a freight price and we will set it up for you. (' + carts + ' carts in this cart — up to five can be ordered online.)';
      return;
    }
    if (digits.length !== 4) {
      return reset('Taxes included. Type your postcode for the exact delivery price, or choose free pickup from Craigieburn at checkout.');
    }
    var res = F.priceFor(digits, grams);
    if (!res || res.error) return reset('That doesn’t look like an Australian postcode. Taxes included; delivery is added at checkout.');
    if (res.quote) return reset('We quote delivery to ' + (F.stateNames[res.state] || res.state) + ' before dispatch. Taxes included.');

    var lane = res.area === 'metro' ? 'Metro' : 'Regional';
    label.textContent = 'Delivery — ' + lane + ' to ' + digits;
    amt.textContent = money(res.amount);
    totalLabel.textContent = 'Estimated total';
    total.textContent = money(subtotal + res.amount) + ' AUD';
    note.textContent = 'Includes delivery to ' + digits + ' and taxes. Checkout re-prices if the address differs. Free pickup from Craigieburn available.';
  }

  /* a new postcode: show "checking" for a beat, then the figure */
  var settle = null;
  function drawSettled(host, digits) {
    clearTimeout(settle);
    var amt = host.querySelector('[data-delivery-amt]');
    var label = host.querySelector('[data-delivery-label]');
    var note = host.querySelector('[data-note]');
    if (digits.length === 4) {
      label.textContent = 'Delivery — checking ' + digits + '…';
      amt.textContent = '…';
      note.textContent = 'Looking up delivery to ' + digits + '…';
      settle = setTimeout(function () { draw(host, digits); }, SETTLE_MS);
    } else {
      draw(host, digits);
    }
  }

  /* the block can be on the page AND in the slide-out drawer at once */
  function init() {
    var hosts = document.querySelectorAll('[data-clikt-cart-delivery]');
    if (!hosts.length) return;
    var F = window.CliktFulfil;
    hosts.forEach(function (host) {
      var input = host.querySelector('[data-pc]');
      var pc = remembered() || host.getAttribute('data-quoted-pc') || (F && F.savedPostcode ? (F.savedPostcode() || '') : '');
      pc = String(pc || '').replace(/\D/g, '').slice(0, 4);
      if (input && document.activeElement !== input) input.value = pc;
      draw(host, input ? input.value : pc);
    });
  }

  /* typing, wherever the block currently is in the DOM */
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-clikt-cart-delivery] [data-pc]')) return;
    var host = t.closest('[data-clikt-cart-delivery]');
    var digits = t.value.replace(/\D/g, '').slice(0, 4);
    if (digits.length === 4) remember(digits);
    drawSettled(host, digits);
  });

  /* Dawn swapped the cart footer or the whole drawer: redraw from the fresh
     attributes. Watching the document is cheap here — only childList changes
     that add or remove a block, debounced. */
  var pending = null;
  var redraw = function () { clearTimeout(pending); pending = setTimeout(init, 60); };
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType === 1 && (n.matches('[data-clikt-cart-delivery]') || n.querySelector('[data-clikt-cart-delivery]') || n.id === 'main-cart-footer' || n.tagName === 'CART-DRAWER' || n.classList.contains('drawer__inner'))) { redraw(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    try { subscribe(PUB_SUB_EVENTS.cartUpdate, redraw); } catch (e) {}
  }

  /* first paint: the rates lib may still be loading */
  var tries = 0;
  (function start() {
    if (window.CliktFulfil && window.CliktFulfil.priceFor) return init();
    if (tries++ < 50) setTimeout(start, 100);
  })();
})();
